export const defaultSiloLogoPath = '../../assets/images/company_logo.png';
